import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-filter-table',
  templateUrl: './filter-table.component.html',
  styleUrls: ['./filter-table.component.scss'],
})
export class FilterTableComponent implements OnInit {
  @Input() isFinishLoadingSubject: BehaviorSubject<boolean>;
  @Input() isOpenFilter: boolean;
  @Input() isActiveFilter: boolean;
  @Input() resetLabel = 'Reset';
  @Output() actionClick = new EventEmitter<string>();
  @Output() actionReset = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  handleOpen = () => {
    this.actionClick.emit();
  };
  handleReset = () => {
    this.actionReset.emit();
  };
}
